(function(){
  'use strict';

  var path = (window.cazaPath ? window.cazaPath() : window.location.pathname).replace(/\/$/, '') || '/';
  if (path !== '/' && path !== '/index') return;

  var LEGACY_SECTION_TOKENS = [
    'featured_collection_a9JeiR',
    'tabs_collection_DV4Abe',
    'featured_collection_H7hpax',
    'blog_post_PLXY4g',
    'hero_image_3Fzrtj'
  ];

  var DUPLICATE_CATEGORY_TOKENS = [
    'collection_item_6qefjb',
    'collection_item_kdUVQx'
  ];

  function topShopifySection(el){
    if (!el) return null;
    if (el.matches && (el.matches('.shopify-section') || /^shopify-section-/.test(el.id || ''))) return el;
    return el.closest ? el.closest('.shopify-section,[id^="shopify-section-"]') : null;
  }

  function removeLegacySections(){
    LEGACY_SECTION_TOKENS.forEach(function(token){
      document.querySelectorAll('[id*="' + token + '"]').forEach(function(match){
        var section = topShopifySection(match);
        if (section && !section.querySelector('#cm-policy-overlay') && !/1646028739ae283905|custom_liquid_XGRPye/.test(section.id || '')) {
          section.remove();
        }
      });
    });
  }

  function removeDuplicateCategories(){
    DUPLICATE_CATEGORY_TOKENS.forEach(function(token){
      document.querySelectorAll('[id*="' + token + '"]').forEach(function(el){
        var block = el.closest('.t4s-collection-item,.t4s-col-item,.t4s-item,.t4s-collection-list-item') || el;
        if (block && block.id && /shopify-section-/.test(block.id)) return;
        block.remove();
      });
    });
  }

  function removeOldReturnPromise(){
    var trust = document.querySelector('[id*="164620932069107a3a"]');
    if (!trust) return;

    var rx = /14\s*DAYS?\s*RETURN/i;
    var marker = Array.prototype.slice.call(trust.querySelectorAll('*')).find(function(el){
      if (!rx.test((el.textContent || '').replace(/\s+/g, ' ').trim())) return false;
      return !Array.prototype.slice.call(el.children || []).some(function(child){
        return rx.test((child.textContent || '').replace(/\s+/g, ' ').trim());
      });
    });
    if (!marker) return;

    var tile = marker.closest('.t4s-col-item,.t4s-shipping-item,.t4s-shipping-list__item,.t4s-shipping__item,[class*="shipping-item"],[class*="service-item"]');
    if (tile && tile !== trust && trust.contains(tile)) {
      tile.remove();
      return;
    }

    var node = marker;
    while (node && node.parentElement && node.parentElement !== trust) {
      var parent = node.parentElement;
      if (parent.children.length >= 2 && (node.textContent || '').trim().length < (parent.textContent || '').trim().length) {
        node.remove();
        return;
      }
      node = parent;
    }
  }

  function removeStaleArtifacts(){
    document.querySelectorAll('.caza-clearance-strip').forEach(function(el){ el.remove(); });
  }

  function cleanup(){
    removeLegacySections();
    removeDuplicateCategories();
    removeOldReturnPromise();
    removeStaleArtifacts();
    document.documentElement.classList.add('caza-home-cleaned-v1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  } else {
    cleanup();
  }

  window.setTimeout(cleanup, 350);
  window.setTimeout(cleanup, 1100);
  document.addEventListener('shopify:section:load', cleanup);
})();
